import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { ShieldCheck, Users, Calendar, Video } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const features = [{
  title: "Data Quality",
  description: "We evaluate your existing data infrastructure to ensure it's ready for high-performance AI models.",
  icon: ShieldCheck
}, {
  title: "Team Skills",
  description: "Assessment of internal capabilities and identifying the training needed for AI enablement.",
  icon: Users
}, {
  title: "Workflow Readiness",
  description: "Mapping high-value business processes that are primed for immediate automation and ROI.",
  icon: Calendar
}];
export default function TheReadinessFramework() {
  return <section data-section-id="257189" id="the-readiness-framework" className="py-16 md:py-24 bg-gradient-to-b from-blue-50 to-background overflow-hidden">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="flex flex-col items-start">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-secondary/10 text-secondary text-sm font-semibold mb-6">
              <Video className="w-4 h-4" />
              <span>Strategic Assessment</span>
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-6 leading-tight">
              The AI Readiness Framework
            </h2>
            
            <p className="text-lg text-muted-foreground font-sans mb-10 max-w-xl">
              Before implementing technology, we measure your organization's maturity across critical pillars to ensure your AI investment delivers measurable business outcomes.
            </p>
            
            <div className="space-y-8 mb-10 w-full">
              {features.map((feature, i) => {
              const Icon = feature.icon;
              return <div key={i} data-index={i} className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-secondary/10 flex items-center justify-center text-secondary">
                      <Icon className="w-6 h-6" />
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold font-default text-foreground mb-1">
                        {feature.title}
                      </h3>
                      <p className="text-muted-foreground font-sans">
                        {feature.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>
            
            <Button size="lg" className="text-base px-8 bg-secondary hover:bg-secondary/90 text-white rounded-lg shadow-md transition-all" asChild>
              <Link to="/AIReadinessPage">Start Your Assessment</Link>
            </Button>
          </div>

          {}
          <div className="relative w-full h-full min-h-[400px] lg:min-h-[600px] rounded-2xl bg-white/50 backdrop-blur-sm border border-border p-4 md:p-8 flex items-center justify-center shadow-lg">
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-secondary/5 rounded-lg blur-3xl pointer-events-none"></div>
            
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686539/img/ai_readiness_framework_diagram.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686539/img/ai_readiness_framework_diagram.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686539/img/ai_readiness_framework_diagram.png-wvc-sizes" alt="AI Readiness Framework Assessment Diagram" className="relative z-10 w-full max-w-md mx-auto h-auto object-contain drop-shadow-xl rounded-lg" loading="lazy" />
            
            {}
            <div className="absolute top-12 left-4 md:left-12 bg-white p-4 rounded-lg shadow-md border border-border flex items-center gap-3 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-100">
              <div className="w-10 h-10 rounded-lg bg-secondary/10 flex items-center justify-center text-secondary">
                <SafeHydrate><Calendar className="w-5 h-5" /></SafeHydrate>
              </div>
              <div>
                <p className="text-sm font-semibold font-default text-foreground">Status: Active</p>
                <p className="text-xs text-muted-foreground font-sans">Workflow Audit</p>
              </div>
            </div>

            <div className="absolute bottom-12 right-4 md:right-12 bg-white p-4 rounded-lg shadow-md border border-border flex items-center gap-3 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-300">
              <div className="w-10 h-10 rounded-lg bg-secondary/10 flex items-center justify-center text-secondary">
                <Video className="w-5 h-5" />
              </div>
              <div>
                <p className="text-sm font-semibold font-default text-foreground">ROI Target</p>
                <p className="text-xs text-muted-foreground font-sans">Measurable Gains</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}